export default __webpack_public_path__ + "static/media/lb-ttg.58d7367b.webp";